export default import.meta.ROLLDOWN_FILE_URL_9w4smEjNx6ecdUwZL_UOCw